import { render, staticRenderFns } from "./changchunStudentList.vue?vue&type=template&id=21a49d61&scoped=true"
import script from "./changchunStudentList.vue?vue&type=script&lang=js"
export * from "./changchunStudentList.vue?vue&type=script&lang=js"
import style0 from "./changchunStudentList.vue?vue&type=style&index=0&id=21a49d61&prod&lang=less"
import style1 from "./changchunStudentList.vue?vue&type=style&index=1&id=21a49d61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a49d61",
  null
  
)

export default component.exports